import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice, nanoid } from '@reduxjs/toolkit'
import { applyNextSearch } from '@/features/search/slice'
import type { EnqueueToastPayload, Toast, ToastQueueState } from './types'

export * from './helpers'
export * from './selectors'
export type * from './types'

const initialState: ToastQueueState = {
  queue: [],
  pageSize: 3,
}

export const toastSlice = createSlice({
  name: 'toasts',
  initialState,
  reducers: {
    enqueueToast: {
      reducer(state, action: PayloadAction<Toast>) {
        const isDuplicate = state.queue.some(
          (t) =>
            t.message === action.payload.message &&
            t.severity === action.payload.severity,
        )
        if (!isDuplicate) {
          state.queue.push(action.payload)
        }
      },
      prepare(payload: EnqueueToastPayload) {
        return {
          payload: {
            ...payload,
            id: payload.id ?? nanoid(),
            dismissMode: payload.dismissMode ?? 'auto',
          },
        }
      },
    },
    dismissToast(state, action: PayloadAction<string>) {
      state.queue = state.queue.filter((t) => t.id !== action.payload)
    },
    dismissAll(state) {
      state.queue = []
    },
    setPageSize(state, action: PayloadAction<number>) {
      state.pageSize = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(applyNextSearch, (state) => {
      state.queue = state.queue.filter(
        (t) => t.dismissMode !== 'search-dismisses',
      )
    })
  },
})

export const { enqueueToast, dismissToast, dismissAll, setPageSize } =
  toastSlice.actions

export default toastSlice.reducer
